module.exports = __webpack_public_path__ + "static/media/usercard.7fe43da5.png";